import './Aside.scss';

import cn from 'classnames';
import { Field, useFormikContext } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';

import ButtonLoading from '@/common/components/molecules/ButtonLoading/ButtonLoading';
import TextField from '@/common/components/molecules/TextField/TextField';
import { ITEM_TYPES, ROLES } from '@/common/constants';
import { useAuth } from '@/common/contexts/AuthContext';
import Total from '@/ebat/components/blocks/Aside/Total/Total';
import Worksite from '@/ebat/components/blocks/Aside/Worksite/Worksite';

import { AsideDefaultProps, AsidePropTypes } from './Aside.proptypes';
import useAside from './useAside';

const Aside = ({
  cart,
  className,
  currentItems,
  disabled,
  isLoading,
  refetchCart,
}) => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { errors, touched } = useFormikContext();

  const { isDisabled } = useAside({
    currentItems,
    disabled,
    isLoading,
  });

  return (
    <div
      className={cn('scanbat-checkout-aside', className)}
      data-qa-id="aside-scanbat"
    >
      <div className="scanbat-checkout-aside__infos">
        <Total
          subtotal={
            user.role === ROLES.CUSTOMER_GUEST
              ? cart.subtotal_incl_vat
              : cart.subtotal
          }
          type={user.role === ROLES.CUSTOMER_GUEST && 'TTC'}
        />
        {user?.role !== ROLES.CUSTOMER_GUEST && (
          <Worksite
            disabled={isDisabled.worksite}
            entity={cart}
            isLoading={isDisabled.loading}
            onSuccess={refetchCart}
            type={ITEM_TYPES.cart}
          />
        )}
      </div>
      <Field
        as={TextField}
        className="scanbat-checkout-aside__reference"
        context="aside-scanbat-reference"
        disabled={isDisabled.manage}
        errors={
          errors.reference &&
          touched.reference && [
            t(`common:messages:forms.validation.${errors.reference}`),
          ]
        }
        id="reference"
        name="reference"
        required={user?.reference_rules?.is_required}
      >
        {t('ebat:entities:checkout.form.reference')}
      </Field>
      <p className="scanbat-checkout-aside__billing">
        {t('ebat:entities:scanbat.checkout.billing')}
      </p>
      <ButtonLoading
        context="aside-scanbat-save"
        buttonSize="large"
        className="scanbat-checkout-aside__validate"
        disabled={isDisabled.validate}
        isLoading={isDisabled.loading}
        variant="primary"
      >
        {t('ebat:messages:actions.validate_order')}
      </ButtonLoading>
    </div>
  );
};

Aside.defaultProps = {
  ...AsideDefaultProps,
};

Aside.propTypes = {
  ...AsidePropTypes,
};

export default Aside;
